export default __webpack_public_path__ + "static/media/mshopilogo.4737c90c.png";